@if (shouldShowThumbnails()) {
  <div class="grid grid-cols-6 gap-4">
    <div>
      <div class="grid grid-cols-1 gap-4">
        @for (file of files(); track file.id; let index = $index) {
          <app-multimedia-tile-thumbnail
            [alt]="file.alt"
            [url]="file.url"
            (clickEvent)="handleSelectClickEvent(index)" />
        }
      </div>
    </div>

    <div class="col-span-5">
      @if (selected(); as selected) {
        <app-multimedia-tile-thumbnail
          [alt]="selected.file.alt"
          [url]="selected.file.id | publicShopFileThumbnailUrl: Large"
          (clickEvent)="handlePreviewClickEvent(selected.index)" />
      } @else {
        <app-multimedia-tile mode="loading" />
      }
    </div>
  </div>
} @else {
  <div class="aspect-[650/650]">
    @if (selected(); as selected) {
      <app-multimedia-tile-thumbnail
        [alt]="selected.file.alt"
        [url]="selected.file.id | publicShopFileThumbnailUrl: Large"
        (clickEvent)="handlePreviewClickEvent(selected.index)" />
    } @else {
      <app-multimedia-tile mode="loading" />
    }
  </div>
}

<p-galleria
  [(activeIndex)]="activeIndex"
  [(visible)]="displayFullScreenGalleria"
  [circular]="true"
  [fullScreen]="true"
  [showItemNavigators]="true"
  [showThumbnails]="false"
  [value]="files()">
  <ng-template
    #item
    let-item>
    <div class="aspect-[650/650] h-[80vh] w-[80vw]">
      <app-image-thumbnail size="full">
        <img
          [alt]="item.alt"
          [fill]="true"
          [ngSrc]="item.id | publicShopFilePreviewUrl"
          class="object-contain" />
      </app-image-thumbnail>
    </div>
  </ng-template>
</p-galleria>
